<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item link="home" label="Test" />
    <item-nav-group :open="true" label="Gruppe">
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
    </item-nav-group>
    <item-nav-group :open="false" label="Gruppe">
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
      <item-nav-group-item label="Test" link="home" />
    </item-nav-group>
  </item-nav>
</template>

<script>

import { isNil } from 'lodash';
import ItemNavGroup from './ItemNavGroup';
import ItemNavGroupItem from './ItemNavGroupItem';

export default {
  name: 'TestNav',
  components: { ItemNavGroupItem, ItemNavGroup },
  props: [],

  data() {
    return {
    };
  },

  computed: {
    navVisible: function () {
      return this.$store.getters['layout/navVisible'];
    },
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    onClickLogo: function () {
      if (this.$route.meta.headerMode === 'white') {
        this.$root.$emit('clickHeaderBack');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/TestNav.vue